// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "status-1LoCh";
var _4 = "title-ypE_C";
var _5 = "title__container-3UIk9";
var _6 = "title__text-24CnL";
var _7 = "title__description-29zKb";
var _8 = "processing-okaYs";
var _9 = "waiting-2hHA5";
var _a = "rejected-1QBqr";
var _b = "success-MlxgQ";
var _c = "right-3-Nbo";
var _d = "icon-24bhs";
var _e = "button-3ecMq";
export { _1 as "__esModule", _2 as "mobile", _3 as "status", _4 as "title", _5 as "title__container", _6 as "title__text", _7 as "title__description", _8 as "processing", _9 as "waiting", _a as "rejected", _b as "success", _c as "right", _d as "icon", _e as "button" }
export default { "__esModule": _1, "mobile": _2, "status": _3, "title": _4, "title__container": _5, "title__text": _6, "title__description": _7, "processing": _8, "waiting": _9, "rejected": _a, "success": _b, "right": _c, "icon": _d, "button": _e }
